import { render, staticRenderFns } from "./EditingHistory.vue?vue&type=template&id=7b9d256a"
import script from "./EditingHistory.vue?vue&type=script&lang=js"
export * from "./EditingHistory.vue?vue&type=script&lang=js"
import style0 from "./EditingHistory.vue?vue&type=style&index=0&id=7b9d256a&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports